import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 my-5" }
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "font-semibold mt-4" }
const _hoisted_7 = { class: "text-sm text-grey-500" }
const _hoisted_8 = { class: "s13 flex justify-content-right" }
const _hoisted_9 = { class: "table separator skin1 selection" }
const _hoisted_10 = {
  class: "btn-circle",
  for: "check_all"
}
const _hoisted_11 = ["checked"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "selection-item" }
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = { class: "flex-right mt-1" }
const _hoisted_17 = ["id", "onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["id"]

import { computed, onMounted, ref } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import axios from 'axios';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesAidesListView',
  setup(__props) {

    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });

    onMounted(() => {
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/categories-aides/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    async function doDeleteItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Catégories Aides", "Voulez-vous vraiment supprimer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/categories-aides/destroy/${item.id}`, {});
                const index = itemsList.value.findIndex(i => i.id == item.id);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function doSelectItem(item: any) {
        selectedItem.value = item;
    }

    function doUnselectItem() {
        selectedItem.value = null;
    }

    async function doToggleEtatValideAction(itemsIds: any[]) {
        const confirmation = await confirmationModalRef.value?.open("Catégories Aides", "Voulez-vous vraiment modifier l'état des éléments sélectionnés ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/categories-aides/toggle_etat_valide`, { ids: itemsIds });

                itemsIds.forEach(itemId => {
                    const index = itemsList.value.findIndex(i => i.id == itemId);
                    if (index > -1) {
                        itemsList.value[index].etat_valide = itemsList.value[index].etat_valide == 1 ? 0 : 1;
                    }
                });

            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, [
                _cache[1] || (_cache[1] = _createTextVNode("Catégories Aides ", -1)),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(itemsList.value.length) + ")", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                id: "btn-add",
                to: "/app/categories-aides/form"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("button", { class: "btn normal ml-4 justify-content-center btn-filtre" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-add.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Créer")
                  ], -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\">Trier</option><option value=\"\" selected>Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div><button class=\"btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter\"><img src=\"/icons/icon-filter.svg\" class=\"btn-icon\" alt=\"\"><span>Options</span></button>", 2))
            ]),
            _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"clear-both\"></div><div class=\"filter-set-area\"><div class=\"grid-filter6 mt-4 mb-0\"><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date1\" id=\"date1\" placeholder=\"\"><label for=\"date1\">Date de création &lt;=</label></div><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date2\" id=\"date2\" placeholder=\"\"><label for=\"date2\">Date de création &gt;=</label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button></div></div>", 2))
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_10, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_11)
                  ])
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Libellé")
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Type")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("th", { class: "flex-right" }, [
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-destroy.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Détruire")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-delete.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Supprimer")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-restaurer.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Restaurer")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra color2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-actif.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Actif")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (itemsList.value.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("td", { colspan: "5" }, [
                      _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'item_' + index,
                  class: "text-grey-700 over-effect over-effect-scale"
                }, [
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("label", {
                      class: "btn-circle",
                      for: 'item_check_' + index
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "selectedItems[]",
                        id: 'item_check_' + index,
                        value: item.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event))
                      }, null, 8, _hoisted_15), [
                        [_vModelCheckbox, selectedItems.value]
                      ])
                    ], 8, _hoisted_14)
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("td", null, [
                    _createElementVNode("div", {
                      class: "square-lg px-3 py-3",
                      style: {"background-color":"rgb(var(--color-success-rgb), 0.1)"}
                    }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-role.svg",
                        width: "100%"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.libelle), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.type_aide), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _cache[14] || (_cache[14] = _createStaticVNode("<button class=\"btn-ultra white2 tips display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-destroy.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Détruire</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1)),
                    _createElementVNode("button", {
                      type: "button",
                      id: 'btn-delete-' + item.id,
                      onClick: ($event: any) => (doDeleteItem(item)),
                      class: "btn-ultra white2 tips"
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "btn-show" }, [
                        _createElementVNode("img", {
                          src: "/icons/icon-delete.svg",
                          class: "btn-icon",
                          alt: ""
                        }),
                        _createElementVNode("span", null, "Supprimer")
                      ], -1),
                      _createElementVNode("div", { class: "btn-loading" }, [
                        _createElementVNode("div", { class: "loader-dots" })
                      ], -1)
                    ]))], 8, _hoisted_17),
                    _cache[15] || (_cache[15] = _createStaticVNode("<button class=\"btn-ultra white2 tips display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-restaurer.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Restaurer</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1)),
                    (item.etat_valide == 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn-ultra color2 tips",
                          onClick: ($event: any) => (doToggleEtatValideAction([item.id]))
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("div", { class: "btn-show" }, [
                            _createElementVNode("img", {
                              src: "/icons/icon-actif.svg",
                              class: "btn-icon",
                              alt: ""
                            }),
                            _createElementVNode("span", null, "Actif")
                          ], -1),
                          _createElementVNode("div", { class: "btn-loading" }, [
                            _createElementVNode("div", { class: "loader-dots" })
                          ], -1)
                        ]))], 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (item.etat_valide == 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn-ultra white2 tips",
                          onClick: ($event: any) => (doToggleEtatValideAction([item.id]))
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("div", { class: "btn-show" }, [
                            _createElementVNode("img", {
                              src: "/icons/icon-inactif.svg",
                              class: "btn-icon",
                              alt: ""
                            }),
                            _createElementVNode("span", null, "Inactif")
                          ], -1),
                          _createElementVNode("div", { class: "btn-loading" }, [
                            _createElementVNode("div", { class: "loader-dots" })
                          ], -1)
                        ]))], 8, _hoisted_19))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: '/app/categories-aides/form/' + item.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn",
                          id: 'btn-edit-' + item.id
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("img", {
                            src: "/icons/icon-edit.svg",
                            class: "btn-icon",
                            alt: ""
                          }, null, -1),
                          _createElementVNode("span", null, "Editer", -1)
                        ]))], 8, _hoisted_20)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})